var _defs, _rect, _text, _text2, _rect2, _text3, _g, _g2, _g3, _g4, _rect3, _text4, _g5, _rect4, _rect5, _text5, _rect6, _text6, _rect7, _text7, _text8, _text9, _text0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapacityPlanningAiAgentsModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1040 672",
    width: 1040,
    height: 672,
    role: "img",
    "aria-label": "A blended capacity model: a human lane measured in usable hours after coordination load, and an agent lane measured in runs and escalation rate, both passing a governance gate into one capacity ledger",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mbg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mgold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mhum",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a4f93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3463"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "marr",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .t    { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#f4f0fc; }\n      .cap  { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#b8b2cc; }\n      .lane { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#efe9fa; }\n      .mono { font-family:'Consolas','SF Mono',Menlo,'DejaVu Sans Mono',monospace; font-weight:600; fill:#cfc3ee; }\n      .pill { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#121020; }\n      .k    { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#cfc3ee; }\n      .num  { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#121020; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1040,
    height: 672,
    rx: 18,
    fill: "url(#mbg)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 54,
    className: "t",
    fontSize: 26
  }, "Two units of capacity, one ledger")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 82,
    className: "cap",
    fontSize: 15
  }, "Humans are bought in seats and spent in hours. Agents are bought in runs and spent in approvals.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 108,
    width: 928,
    height: 44,
    rx: 10,
    fill: "url(#mgold)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 136,
    textAnchor: "middle",
    className: "pill",
    fontSize: 17
  }, "DEMAND: the work the quarter actually requires")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#8f7fd0",
    strokeWidth: 2.5,
    fill: "none",
    markerEnd: "url(#marr)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 152 V 190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 152 V 190"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 192,
    width: 432,
    height: 214,
    rx: 14,
    fill: "#1d1a2e",
    stroke: "#4c4380",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 192,
    width: 432,
    height: 38,
    rx: 14,
    fill: "url(#mhum)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 218,
    className: "lane",
    fontSize: 17
  }, "Human lane &#8212; fixed, discrete"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 256,
    className: "cap",
    fontSize: 14
  }, "Unit of capacity"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 278,
    className: "mono",
    fontSize: 13
  }, "usable hours ="), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 297,
    className: "mono",
    fontSize: 13
  }, "FTE x available hrs x (1 - coordination load)"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 332,
    className: "cap",
    fontSize: 14
  }, "What shrinks it"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 354,
    className: "k",
    fontSize: 14
  }, "meetings, incidents, context switching, unplanned work"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 386,
    className: "cap",
    fontSize: 14
  }, "Ramp: weeks to months &#183; Cost: salary, fixed"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 192,
    width: 432,
    height: 214,
    rx: 14,
    fill: "#1d1a2e",
    stroke: "#4c4380",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 192,
    width: 432,
    height: 38,
    rx: 14,
    fill: "url(#mai)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 218,
    className: "pill",
    fontSize: 17
  }, "Agent lane &#8212; elastic, metered"), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 256,
    className: "cap",
    fontSize: 14
  }, "Unit of capacity"), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 278,
    className: "mono",
    fontSize: 13
  }, "throughput ="), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 297,
    className: "mono",
    fontSize: 13
  }, "runs/day x tasks per run x (1 - escalation rate)"), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 332,
    className: "cap",
    fontSize: 14
  }, "What shrinks it"), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 354,
    className: "k",
    fontSize: 14
  }, "bad data, missing permissions, review queues, rate limits"), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 386,
    className: "cap",
    fontSize: 14
  }, "Ramp: days &#183; Cost: per run, variable"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#8f7fd0",
    strokeWidth: 2.5,
    fill: "none",
    markerEnd: "url(#marr)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272 406 C 272 436, 420 434, 452 456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 406 C 768 436, 620 434, 588 456"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 460,
    width: 424,
    height: 52,
    rx: 26,
    fill: "url(#mai)"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 492,
    textAnchor: "middle",
    className: "pill",
    fontSize: 16
  }, "Governance gate: scope, approvals, audit trail")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#8f7fd0",
    strokeWidth: 2.5,
    fill: "none",
    markerEnd: "url(#marr)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520 512 V 544"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 548,
    width: 928,
    height: 60,
    rx: 12,
    fill: "#241f3d",
    stroke: "#4c4380",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 554,
    width: 372,
    height: 48,
    rx: 8,
    fill: "url(#mhum)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 248,
    y: 584,
    textAnchor: "middle",
    className: "lane",
    fontSize: 15
  }, "usable human hours")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 554,
    width: 300,
    height: 48,
    rx: 8,
    fill: "url(#mai)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 584,
    textAnchor: "middle",
    className: "num",
    fontSize: 15
  }, "agent throughput")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 746,
    y: 554,
    width: 232,
    height: 48,
    rx: 8,
    fill: "#171523",
    stroke: "#665a9c",
    strokeWidth: 1.5,
    strokeDasharray: "5 5"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 862,
    y: 578,
    textAnchor: "middle",
    className: "k",
    fontSize: 14
  }, "reserve for")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 862,
    y: 596,
    textAnchor: "middle",
    className: "k",
    fontSize: 14
  }, "escalations")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 638,
    className: "cap",
    fontSize: 14
  }, "One plan. Two units. Every unit traceable to the outcome it was funded for.")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 984,
    y: 638,
    textAnchor: "end",
    className: "k",
    fontSize: 14,
    opacity: 0.9
  }, "BOSSDROP.AI")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacityPlanningAiAgentsModel);
export default __webpack_public_path__ + "static/media/capacity-planning-ai-agents-model.70bd44bd2482bc544ef83173b8cca5bd.svg";
export { ForwardRef as ReactComponent };